import React from "react";
import styled from "styled-components";
import { NavLink } from "react-router-dom";


const Primary = styled.div`
  text-align: center;
  display: block;
  text-decoration: none;

  .icon {
    font-size: 30px;
    color: var(--color-sidebar-text-general);

    &:nth-child(1) {
      padding-top: 1rem;
    }
  }

  .title {
    padding-bottom: 1rem;
    color: var(--color-sidebar-text-general);
    min-height: 46px;
  }

  .nav-link-active {
    display: block;
    background-color: var(--color-sidebar-pink-selected);
    transition: all 0.3s ease-in-out;
  }

  .nav-link-active > .title {
    color: var(--color-brand-pink-primary);
    font-weight: bold;
    transition: all 0.3s ease-in-out;
  }

  .nav-link-active > .icon {
    filter: invert(32%) sepia(90%) saturate(1409%) hue-rotate(314deg)
      brightness(96%) contrast(92%);
  }
`;

const NavEntry = ({ icon, title, target }) => {
  return (
    <Primary id={title.split(' ').join('-')}>
      <NavLink
        to={target}
        tabIndex={1}
        style={{ textDecoration: "none" }}
        className={({ isActive }) => (isActive ? "nav-link-active" : "")}
        id={title.split(' ').join('-')}
      >
        <div className={"icon"}>{icon}</div>
        <div className={"title"}>{title}</div>
      </NavLink>
    </Primary>
  );
};

export default NavEntry;
